export const Button = {
  defaultProps: {
    focusBorderColor: 'brand.secondary',
  },
}
